export const defaultConfig: any = {
  position: 'top-right',
  //duration: 400000,
  //isClosable: true,
  height: '100%',
  containerStyle: {
    height: '100%',
  },
};
